const modal = document.getElementById('price-modal');

if (modal) {
    const content = modal.querySelector('.price-modal__content');
    const globalContent = content.innerHTML;

    const open = (customDisclaimer) => {
        if (customDisclaimer) {
            content.innerHTML = customDisclaimer;
        } else {
            content.innerHTML = globalContent;
        }
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
    };

    const close = () => {
        modal.hidden = true;
        document.body.style.overflow = '';
    };

    document.querySelectorAll('[data-price-tooltip-trigger]').forEach((btn) => {
        btn.addEventListener('click', () => {
            open(btn.dataset.disclaimer || '');
        });
    });

    modal.querySelectorAll('[data-price-modal-close]').forEach((el) => {
        el.addEventListener('click', close);
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) close();
    });
}
